module.exports = __webpack_public_path__ + "media/images/users/registrations/flow-5-7bcff84a32ed606d21ad26938579e076.png";